import { CountryIso3Code, CurrencyCode } from '@domgen/dgx-fe-i18n';
import { RegistrationChannel } from '../../models/registration/registration-channel.enum';
import { RegistrationRequest } from '../../models/registration/registration-request.interface';
import { RegistrationSystemCode } from '../../models/registration/registration-system-code.enum';
import { mockCustomerDetails } from '../customer/customer-details.mock';
import { mockRegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.mock';

export const mockRegistrationRequest: RegistrationRequest = {
  channel: RegistrationChannel.Web,
  client: 'Whirlpool',
  country: CountryIso3Code.UnitedStates,
  currency: CurrencyCode.USDollar,
  customer: mockCustomerDetails,
  merchandise: [mockRegistrationApplianceDetails],
  system: RegistrationSystemCode.InternetProductRegistration,
};
